module.exports = __webpack_public_path__ + "static/gallery19-53c0256bf0e2eb069e018c38beb4d78b.jpg";